import React, { FC, memo, ReactElement } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useIssuePersonalInvoice } from '../utils/hooks/useIssuePersonalInvoice';
import { Invoice, InvoiceItem } from 'entities/Invoice';

interface IssuePersonalInvoiceProps {
  warehouseId: string | undefined;
  userId: string | undefined;
  invoiceData: Nullable<Partial<Invoice>> | undefined;
  invoiceItems: InvoiceItem[];
  action: ReactElement;
  onSuccess?: () => void;
}

export const IssuePersonalInvoice: FC<IssuePersonalInvoiceProps> = memo((props) => {
  const { invoiceData, invoiceItems = [], warehouseId, userId, action, onSuccess } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const { handleIssueUserInvoice, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useIssuePersonalInvoice({
    invoiceData,
    invoiceItems,
    warehouseId,
    userId,
    onSuccess,
  });

  return (
    <>
      {React.cloneElement(action, { onClick: openConfirmModal })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Create Invoice')}
        description={t('Are you sure you want to create invoice?')}
        isLoading={isLoading}
        onOk={handleIssueUserInvoice}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
